import React from "react";
import PropTypes from "prop-types";
import { useVideoDataContext } from "../contexts/VideoDataContext";
import { useOrcaCommonContext } from "../contexts/OrcaCommonContext";
import { usePromoContext } from "../contexts/PromoContext";
import { Wrapper } from "./Wrapper";
export const OrcaWrapper = ({ children, config }) => {
  const { videoData } = useVideoDataContext();
  const { playerWrapperRef } = useOrcaCommonContext();
  const { promoState } = usePromoContext();
  const {
    caption,
    className,
    placeholder,
    aspectRatio: _aspectRatio,
    aspectWidth = 16,
    aspectHeight = 9,
    buildPromoImagePropsOverride
  } = config;

  const aspectRatio = _aspectRatio || aspectHeight / aspectWidth;

  const streamAspectRatio =
    videoData?.streams?.[0].height / videoData?.streams?.[0].width;

  const aspectMatch = aspectRatio === streamAspectRatio;
  return (
    <div ref={playerWrapperRef}>
      <Wrapper
        {...{
          aspectRatio,
          aspectMatch,
          placeholder,
          className,
          caption,
          promoState,
          buildPromoImagePropsOverride
        }}
      >
        {children}
      </Wrapper>
    </div>
  );
};

OrcaWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  config: PropTypes.object
};
